import { Component, Input, OnInit } from "@angular/core";
import { JobSettingsViewModel } from "../job-settings.view-model";

@Component({
  selector: "evrideo-priotiry-level",
  templateUrl: "./priotiry-level.component.html",
  styleUrls: ["./priotiry-level.component.scss"],
})
export class PriotiryLevelComponent implements OnInit {
  @Input()
  vm: JobSettingsViewModel;
  constructor() {}

  ngOnInit() {}
}
